import React, { Component } from 'react'

// redux
import { connect } from 'react-redux'
import userAction from '../../redux/user/actions'
import organizationActions from '../../redux/organization/actions'

// sub component
import HeadBar from './headbar'
import ListUsers from './list_users'
import Paginate from './paginate'
import ModalUserInfo from './modal_user_info'
import ModalConfirmDelete from './modal_confirm_delete'
import ModalConfirmBan from './modal_confirm_ban'
import ModalResetPassword from './modal_reset_password'

class UsersScreen extends Component {
    componentDidMount() {
        const loadType = organizationActions.loadType.GET_NOT_DELETED
        this.props.loadListOrganizations(loadType)

        this.props.getListUser({
            status: 0
        })
        
    }

    render() {
        const { height } = this.props
        return (
            <div className="UsersScreen">
                <div className="MainCard" style={{ minHeight: height - 100 }}>
                    <HeadBar />
                    <ListUsers />
                    <Paginate />

                    <ModalConfirmDelete />
                    <ModalUserInfo />
                    <ModalConfirmBan />
                    <ModalResetPassword />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.app,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getListUser: params => {
            dispatch(userAction.action.setInitState())
            dispatch(userAction.action.getListUsers(params))
            dispatch(userAction.action.getListRole())
        },
        loadListOrganizations: loadtype => {
            dispatch(organizationActions.action.loadListOrganization(loadtype))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UsersScreen)
